/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentSlotsRequest
 */
export interface AppointmentSlotsRequest {
    /**
     * 
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    physician_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    concern_id: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    clinic_id?: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSlotsRequest
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    type: AppointmentSlotsRequestTypeEnum;
    /**
     * Required to disambiguate a telemedicine concern's Video vs Phone delivery options. Without it resolveDeliveryOptionIndex matches zero options and the slot length falls back to the concern default, ignoring the option's `minutes` override.
     * @type {string}
     * @memberof AppointmentSlotsRequest
     */
    telemedicine_method?: AppointmentSlotsRequestTelemedicineMethodEnum;
    /**
     * Absolute position in the concern's `delivery_options`. Slot length must be computed from the SAME effective duration the booking will be stamped with (resolveConcernMinutes), otherwise the patient picks from a grid sized to the concern default and books an appointment of a different length.
     * @type {number}
     * @memberof AppointmentSlotsRequest
     */
    delivery_option_index?: number;
}


/**
 * @export
 */
export const AppointmentSlotsRequestTypeEnum = {
    Video: 'Video',
    Home: 'Home',
    Clinic: 'Clinic',
    Blocked: 'Blocked',
    Lab: 'Lab'
} as const;
export type AppointmentSlotsRequestTypeEnum = typeof AppointmentSlotsRequestTypeEnum[keyof typeof AppointmentSlotsRequestTypeEnum];

/**
 * @export
 */
export const AppointmentSlotsRequestTelemedicineMethodEnum = {
    Video: 'Video',
    Phone: 'Phone'
} as const;
export type AppointmentSlotsRequestTelemedicineMethodEnum = typeof AppointmentSlotsRequestTelemedicineMethodEnum[keyof typeof AppointmentSlotsRequestTelemedicineMethodEnum];


/**
 * Check if a given object implements the AppointmentSlotsRequest interface.
 */
export function instanceOfAppointmentSlotsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "concern_id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function AppointmentSlotsRequestFromJSON(json: any): AppointmentSlotsRequest {
    return AppointmentSlotsRequestFromJSONTyped(json, false);
}

export function AppointmentSlotsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentSlotsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'physician_id': !exists(json, 'physician_id') ? undefined : json['physician_id'],
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'concern_id': json['concern_id'],
        'clinic_id': !exists(json, 'clinic_id') ? undefined : json['clinic_id'],
        'date': json['date'],
        'type': json['type'],
        'telemedicine_method': !exists(json, 'telemedicine_method') ? undefined : json['telemedicine_method'],
        'delivery_option_index': !exists(json, 'delivery_option_index') ? undefined : json['delivery_option_index'],
    };
}

export function AppointmentSlotsRequestToJSON(value?: AppointmentSlotsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'physician_id': value.physician_id,
        'patient_id': value.patient_id,
        'concern_id': value.concern_id,
        'clinic_id': value.clinic_id,
        'date': value.date,
        'type': value.type,
        'telemedicine_method': value.telemedicine_method,
        'delivery_option_index': value.delivery_option_index,
    };
}

